export const LOADING = 'LOADING';
export const INVALID_CONFIGURATION = 'INVALID_CONFIGURATION';
export const FIND_APPOINTMENT = 'FIND_APPOINTMENT';
export const SELECT_APPOINTMENT = 'SELECT_APPOINTMENT';
export const CLIENT_INFORMATION = 'CLIENT_INFORMATION';
export const CONFIRMATION = 'CONFIRMATION';
export const APPOINTMENT_CONFIRMED = 'APPOINTMENT_CONFIRMED';

export const PAGE_INTRO = '/select-tour';
export const PAGE_DATE_SELECT = '/select-time';
export const PAGE_PREFERENCES = '/preferences';
export const PAGE_INFO = '/info';
export const PAGE_CONFIRMED = '/confirmed';
export const PAGE_CANCELLED = '/cancelled';
export const PAGE_TOUR_PASSED = '/tour-passed';
export const PAGE_TOUR_RESCHEDULE = '/reschedule';
export const PAGE_NEARBY_COMMUNITY = '/nearby-community/:communityId';

export const MAX_MOBILE_WIDTH = 768;

export const CONTACT_INFO_REQUIRED_ERROR = 'Phone or Email is required';
